import {useEffect, useMemo} from "react";
import {useHistory} from "react-router-dom";
import {routesBase} from "v4/data/appRoutes";
import {usePolTranslation} from "v4/hooks/usePolTranslation";
import useNotification from "v4/hooks/useNotification";
import useFetch from "v4/hooks/useFetch";
import apiService from "v4/services/api.service";
import {
    CUSTOM_EVENT_TRIGGER_ADD,
    CUSTOM_EVENT_TRIGGER_EDIT,
    CUSTOM_EVENT_TRIGGER_FORM,
    CUSTOM_EVENT_TRIGGER_ITEM
} from "v4/data/apiRoutes";
import useAutoFetch from "v4/hooks/useAutoFetch";
import schemaFormToV4Form from "v4/utils/schemaFormToV4Form";

export default function useCustomEventTriggersForm(customerId, id) {
    const {t} = usePolTranslation();
    const {addSuccessNotification, addErrorNotification} = useNotification();
    const {push} = useHistory();

    const {data: customEventTriggerFormData, isLoading} = useAutoFetch(
        id
            ? apiService.generateUrl(CUSTOM_EVENT_TRIGGER_EDIT, {id: id, customerId: customerId})
            : apiService.generateUrl(CUSTOM_EVENT_TRIGGER_FORM, {customerId: customerId}),
        id
    );

    const form = useMemo(() => {
        if (!customEventTriggerFormData) return null;

        return {
            results: schemaFormToV4Form(customEventTriggerFormData)
        }

    }, [customEventTriggerFormData])

    const [{
        data: customEventTriggerDataSave,
        isError: isErrorSave,
        isLoading: isLoadingSave,
        isFinished: isFinishedSave
    }, customEventTriggerSaveFetch] = useFetch();

    const handleSave = (data, methods) => {
        if ('specific_field' !== methods.getValues('type')) {
            methods.unregister('specificFieldId');
        }

        if ('condition_contains_tasks' !== methods.getValues('aCondition')) {
            methods.unregister('containValues');
        }

        customEventTriggerSaveFetch({
            url: id
                ? apiService.generateUrl(CUSTOM_EVENT_TRIGGER_ITEM, {id})
                : apiService.generateUrl(CUSTOM_EVENT_TRIGGER_ADD),
            config: {
                method: 'POST',
                headers: {
                    Accept: 'application/ld+json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            }
        })
    }

    useEffect(() => {
        if (!isFinishedSave) return;

        if (isErrorSave) return addErrorNotification(t('custom_event_trigger_save_error'))

        addSuccessNotification(t('custom_event_trigger_save_done'))
        push(routesBase.adminCustomEventTriggers);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customEventTriggerDataSave, isErrorSave, isFinishedSave])

    return {
        form,
        isLoading,
        isLoadingSave,
        handleSave,
    }
}
